const CROSSFADE_DURATION_MS = 150;
const wrapperCls = "_61w1xvjxtl";
const container = "_61cxw0mya";
const transitionWrapperCls = "_61t1457g20";
const breadcrumbsCls = "_61b1rriudi";
const breadcrumbCls = "_61b1r5ewj9";
const subNavigationButtonCls = "_61sg8omt6";
const chevronCls = "_61c6vik8y";
const labelCls = "_61l1n8tar9";
const outlineCls = "_61o1bg0nde";
const linkCls = "_61l1ngnsyt";
const truncateCls = "_61t12syl8w";

export { CROSSFADE_DURATION_MS, breadcrumbCls, breadcrumbsCls, chevronCls, container, labelCls, linkCls, outlineCls, subNavigationButtonCls, transitionWrapperCls, truncateCls, wrapperCls };
import "./root.breadcrumb.style.linaria.module.css";
//# sourceMappingURL=root.breadcrumb.style.js.map
